import { Signal, createSignal } from 'solid-js'
import { gridGeneratorBtn as api } from 'st-app/api'
import { WritingStylePrompt } from 'st-app/api';

const [writingStyles, setWritingStyles] = createSignal<Array<WritingStylePrompt>>();

let writingStylesInitialized = false;
export class GridStore {
    constructor() {
        if (!writingStylesInitialized) {
            writingStylesInitialized = true;
            api.GetWritingStyles().then(styles => {
                setWritingStyles(styles);
            }).catch(console.error);
        }
    }

    get styles() { return writingStyles() || []; }

    myWritingStyle(): WritingStylePrompt {
        return this.styles[0] || new WritingStylePrompt();
    }

    getWritingStyle(id: string) {
        return this.styles.find(ws => ws.writingStyleGU === id) || this.myWritingStyle();
    }

    setMyWritingStyle(style: WritingStylePrompt) {
        api.SaveWritingStyle(style);

        const [myStyle, ...otherStyles] = this.styles;
        setWritingStyles([style, ...otherStyles])
    }
}
